import {
  Card,
  Flex,
  Heading,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@aws-amplify/ui-react";
import React, { useMemo } from "react";
import { Assignment, AssignmentResult, Student } from "../../types";
import { ResultsTableRow } from "./ResultsTableRow";
import { QuestionNumberButton } from "./QuestionNumberButton";
import { exportResultsTable } from "../../util/exportResultsTable";
import { RaisedButton } from "../../../../components";
import { FaDownload } from "react-icons/fa";
import { useQueries } from "@tanstack/react-query";
import { getStudent } from "../../util";
import { useParams } from "react-router-dom";

export default function ResultsTable({
  assignment,
  assignmentResults,
}: {
  assignment: Assignment;
  assignmentResults: AssignmentResult[];
}) {
  const { classId } = useParams();

  const questions = useMemo(() => {
    return (
      assignment.quiz.Questions?.items?.map((quizQuestion) => {
        return quizQuestion?.question;
      }) ?? []
    );
  }, [assignment]);

  const playerQueries = useQueries({
    queries: assignmentResults.map((result) => ({
      queryKey: ["assignment-results", result.id, "players", result.studentId],
      queryFn: async () => {
        if (!classId) throw new Error("Class ID not found");
        return await getStudent(classId, result.studentId);
      },
      enabled: !!classId,
    })),
  });

  const players: Student[] = useMemo(() => {
    const players = playerQueries
      .flatMap((playerQuery) => playerQuery.data)
      .filter((p) => p !== undefined) as Student[];

    return players;
  }, [playerQueries]);

  return (
    <>
      <Card boxShadow={"large"}>
        <Flex direction={"column"} padding={"small"}>
          <Flex justifyContent={"space-between"} alignItems={"end"}>
            <Heading paddingBottom={"xs"}>Results</Heading>
            <RaisedButton
              variation="link"
              onClick={() => {
                exportResultsTable(assignmentResults, players, questions);
              }}
            >
              <FaDownload />
            </RaisedButton>
          </Flex>
          <ScrollView>
            <Table size="small" variation={"striped"}>
              <TableHead>
                <TableRow>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Student
                  </TableCell>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Attempt
                  </TableCell>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Score
                  </TableCell>
                  <TableCell as="th" width={"500px"}>
                    <Flex justifyContent="start">
                      {questions?.map((question, i) => (
                        // <Text>Hi</Text>
                        <QuestionNumberButton
                          key={i}
                          question={question}
                          qNumber={i + 1}
                        />
                      ))}
                    </Flex>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assignmentResults.map((result) => (
                  <ResultsTableRow
                    key={result.id}
                    assignmentResult={result}
                    questions={questions}
                  />
                ))}
              </TableBody>
            </Table>
          </ScrollView>
        </Flex>
      </Card>
    </>
  );
}
